<template>
  <div class="profile-main-box"
       :class="[{'is-mobile': isMobile}]">
    <div class="profile-info-box">
      <transition name="fade" mode="out-in">
        <custom-skeleton key="loading" v-if="loading" type="profile" />
        <div class="profile-sidebar-box" v-else>
          <div class="header-sidebar-profile-box" :class="{'has-content': profile.name || (!isMobile && (hasEditProfile || hasBack))}">
            <div v-if="hasEditProfile && !isMobile" class="edit-profile-icon" :class="[{'dir-ltr': !$vs.rtl}]" @click="$emit('editProfile')">
              <custom-icon icon="edit-icon" height="22px" width="20px" color="warning" />
            </div>
            <div v-if="hasDelete && !isMobile" class="edit-profile-icon" :class="[{'dir-ltr': !$vs.rtl}]" @click="$emit('delete')">
              <custom-icon icon="trash-icon" height="22px" width="20px" color="danger" />
            </div>
            <div v-if="profile.name" class="profile-name w-auto">
              <div>
                {{ profile.name }}
              </div>
            </div>
            <div v-if="!isMobile && hasBack" class="profile-back-icon" :class="[{'dir-ltr': !$vs.rtl}]" @click="$u.click('routeBackBTN')">
              <custom-icon icon="chevron-left-icon" height="22px" width="20px" />
            </div>
          </div>
          <div class="body-sidebar-profile-box">
            <div class="profile-box">
              <template v-if="profile.avatar">
                <div @click="imagePreviewStatus = true"
                     class="profile-avatar-box">
                  <lazy-image class="profile-avatar cursor-pointer"
                              :class="[typeof profile.avatar === 'object' ? `size-${profile.avatar.size}` : '']"
                              :src="typeof profile.avatar === 'object' ? profile.avatar.value : profile.avatar"
                              :alt="profile.name"/>
                </div>

                <image-preview v-if="imagePreviewStatus"
                               :image="{src: typeof profile.avatar === 'object' ? profile.avatar.value : profile.avatar, alt: profile.name}"
                               @closed="imagePreviewStatus = false"/>
              </template>

              <div v-if="profile.details"
                   v-for="(detail, detail_index) in profile.details"
                   :key="detail_index">

                <div class="profile-details w-auto mx-auto">

                  <vs-icon v-if="detail.icon"
                           class="w-auto inline-block mr-1"
                           :icon="detail.icon"
                           :icon-pack="detail.iconPack"/>

                  <div class="w-auto inline-block">
                    {{ `${detail.key} ${detail.key ? ':' : ''} ${detail.value}` }}
                  </div>
                </div>
              </div>

              <div class="important-data-list">
                <div class="important-data-item"
                     :class="important_data.class || ''"
                     v-for="(important_data, important_data_index) in profile.importantData"
                     :key="important_data_index">
                  <div class="key w-full useral-font-weight-medium">
                    {{ important_data.key }}
                  </div>
                  <div v-if="important_data.hasOwnProperty('type') && important_data.type === 'price'"
                       class="value w-full mt-1"
                       :class="important_data.valueClass">
                    {{ $u.priceFormat(important_data.value, true) }}
                  </div>

                  <div v-else
                       class="value w-full mt-1"
                       :class="important_data.valueClass">
                    {{ important_data.value }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="getImportantActions.length > 0" class="important-actions-box">
              <ul class="important-actions-list">
                <template v-for="(action, action_index) in getImportantActions">
                  <profile-action :action="action" :key="action_index" :selected-action="selectedAction" @eventClick="(event) => handleClickAction(event, action)" />
                </template>
              </ul>
            </div>

            <div class="actions-list-box">
              <ul class="actions-list">
                <template v-for="(action, action_index) in actionsList.filter(elm => elm.type !== 'important')">
                  <profile-action :action="action" :key="action_index" :selected-action="selectedAction" @eventClick="(event) => handleClickAction(event, action)" />
                </template>
              </ul>
            </div>

            <div class="description" v-if="profile.description">
              <p>{{ profile.description }}</p>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="(!isMobile || this.$store.state.pageHaveChanges) && !loading" class="profile-content-box">
      <the-content-navbar />
      <div class="profile-content" :class="contentClass">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from '@/components/lazyImage/lazyImage'
import ImagePreview from '@/components/imagePreview/imagePreview'
import CustomIcon from '../icon/customIcon'
import historyStates from '../../mixins/historyStates'
import ProfileAction from './profileAction.vue'
import {mapGetters} from 'vuex'
import TheContentNavbar from '../../layouts/components/navbar/TheContentNavbar.vue'
import CustomSkeleton from '@/components/skeleton/index.vue'

export default {
  name: 'profileMainBox',
  components: {
    CustomSkeleton,
    TheContentNavbar,
    ProfileAction,
    CustomIcon,
    ImagePreview,
    LazyImage
  },
  mixins: [historyStates],
  props: {
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    actionsList: {
      type: Array,
      default () {
        return []
      }
    },
    activeActionKey: {
      type: String,
      default: 'event'
    },
    defaultAction: {
      type: String,
      default () {
        return ''
      }
    },
    hasEditProfile: {
      type: Boolean,
      default () {
        return true
      }
    },
    hasDelete: {
      type: Boolean,
      default () {
        return false
      }
    },
    hasBack: {
      type: Boolean,
      default () {
        return true
      }
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imagePreviewStatus: false,
      selectedAction: ''
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    getImportantActions () {
      return this.actionsList.filter(elm => elm.type === 'important')
    },
    loading () {
      return !(this.profile && Object.keys(this.profile).length > 0)
    }
  },
  created () {
    if (!this.isMobile) {
      this.selectedAction = this.defaultAction
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.resizeProfileNameText()
    })
  },
  methods: {
    handleClickAction (event, action) {
      if (action.actionType !== 'modal') {
        this.selectedAction = this.activeActionKey === 'name' ? action.name : action.event
      }
      this.$emit(action.event, action)
    },

    resizeProfileNameText () {
      const textEl = document.querySelectorAll('.profile-name div')[0]
      if (textEl) {
        this.$u.resizeTextOverflow({
          element: textEl,
          maxSize: 16,
          minSize: 5,
          unit: 'px'
        })
      }
    }
  },
  watch: {
    'defaultAction': {
      handler (val) {
        if (val !== this.selectedAction) {
          this.selectedAction = val
        }
      }
    },
    'profile.name': {
      handler () {
        this.$nextTick(() => {
          this.resizeProfileNameText()
        })
        setTimeout(() => {
          this.resizeProfileNameText()
        }, 320)
      },
      deep: true
    },
    '$route.name': {
      handler (val) {
        this.selectedAction = val
      }
    }
  }
}
</script>

<style lang="scss">
.vx-navbar-wrapper.content-navbar.bottom-border-radius-0.profile-page-navbar {
  border-bottom: 1px solid #f5f5f5 !important;

  .vs-navbar {
    box-shadow: none !important;
  }

  .bottom-shadow {
    display: none;
  }
}

.profile-main-box {
  $marginSpace: 15px;

  display: flex;
  height: 100%;
  padding: 0;

  .vx-card__body {
    padding: 0 !important;
  }

  .profile-info-box {
    width: 300px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    direction: rtl;
    position: relative;
    background-color: #fff;
    border-radius: 0.5rem;
    border: 1px solid #cecece;

    &::-webkit-scrollbar {
      display: block;
      background: rgba(206, 206, 206, 0.50);
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      background: rgba(206, 206, 206, 1);
      border-radius: .5rem;
    }

    * {
      direction: ltr;
    }

    .edit-profile-icon,
    .profile-back-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;

      &.edit-profile-icon {
        left: 10px;

        &.dir-ltr {
          left: unset;
          right: 10px;
        }
      }

      &.profile-back-icon {
        right: 10px;

        &.dir-ltr {
          right: unset;
          left: 10px;
        }
      }
    }

    .profile-sidebar-box {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      height: 100%;
    }

    .header-sidebar-profile-box {
      position: relative;
      padding: $marginSpace;
      padding-bottom: 0;
      border-bottom: 1px solid #f5f5f5;

      &.has-content {
        min-height: 56px;
      }

      .profile-name {
        width: 100%;
        height: 25px;
        font-size: 15px;
        line-height: 25px;
        font-weight: 700;
        margin-bottom: 15px;
        padding: 0 15px;
        text-align: center;
        overflow-x: auto;

        &::-webkit-scrollbar {
          display: block;
          background: rgba(206, 206, 206, 0.50);
          width: 3px;
        }

        &::-webkit-scrollbar-thumb {
          display: block;
          background: rgba(206, 206, 206, 1);
          border-radius: .5rem;
        }
      }
    }

    .body-sidebar-profile-box {
      flex: 1;
      overflow-y: auto;
    direction: rtl;

      &::-webkit-scrollbar {
        display: block;
        background: rgba(206, 206, 206, 0.50);
        width: 3px;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
        background: rgba(206, 206, 206, 1);
        border-radius: .5rem;
      }

      * {
        direction: ltr;
      }
    }

    .profile-box {
      padding-top: 10px;

      .profile-avatar-box {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;

        .profile-avatar {
          object-fit: cover;
          aspect-ratio: 1 / 1;
          border-radius: 25px;
          max-width: 120px;
          height: 120px;
        }
      }

      .profile-details {
        text-align: center;

        &:first-of-type {
          padding-top: $marginSpace;
        }

        &:last-of-type {
          padding-bottom: $marginSpace;
          border-bottom: 1px solid #f5f5f5;
        }
      }

      .important-data-list {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .important-data-item {
          text-align: center;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: fit-content !important;
          padding: $marginSpace;

          .key {
            font-size: 12px;
            color: #999999;
            margin-top: 3px;
          }

          .value {
            font-size: 15px;
            font-weight: 600;
          }
        }
      }
    }

    .important-actions-box {
      padding: $marginSpace 0;
      margin-bottom: $marginSpace;
      border-bottom: 1px solid #f5f5f5;

      .important-actions-list {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }
    }

    .actions-list-box {
      .actions-list {

        a {


          &:last-child {

            li {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .description {
      padding: $marginSpace;
      margin: auto;
      margin-top: $marginSpace;
      line-height: 25px;
      background: #ffffff;
      border-top: 1px solid #f5f5f5;
      border-radius: .5rem;
      box-shadow: 0px 4px 10px -3px cecece;

      p {
        text-align: justify;
      }
    }
  }

  .profile-content-box {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 315px);
    flex: 1;
    margin-left: $marginSpace;
    background-color: #fff;
    border-radius: 0.5rem;
    border: 1px solid #cecece;

    .vx-navbar-wrapper.content-navbar {
      border: 0 !important;
    }

    .profile-content {
      flex: 1;
      padding: $marginSpace;
      overflow: auto;

      &::-webkit-scrollbar {
        display: block;
        background: rgba(206, 206, 206, 0.50);
        width: 3px;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
        background: rgba(206, 206, 206, 1);
        border-radius: .5rem;
      }

      &.without-padding {
        padding: 0;

        .draggable-dynamic-table {
          .table-wrapper {
            border: none;
            border-radius: 0 0 0.5rem 0.5rem;
          }
        }

        .main-box {
          border-radius: 0 !important;
        }
      }
    }
  }

  &.is-mobile {
    .profile-info-box {
      max-width: unset;
      min-width: unset;
      width: unset;
      flex: 1;
      border-radius: 0;
      border: none;

      .profile-box {
        .profile-avatar-box {
          .profile-avatar {
            width: 50%;
            height: auto;

            &.size-small {
              width: 33%;
              height: auto;
            }

            &.size-medium {
              width: 50%;
              height: auto;
            }

            &.size-big {
              width: 80%;
              height: auto;
            }
          }
        }
      }
    }

    .profile-content-box {
      border: none;
    }
  }
}
</style>
